import { useContext } from "react";
import { PageSizeContext } from "../../../context/context.page";

const PageSize = () => {
  const { pageSize, changePageSize } = useContext(PageSizeContext);
  return (
    <select
      className="select w-full bg-base-100/70"
      onChange={(e) => changePageSize(Number(e.target.value))}
      value={pageSize}
    >
      <option value={12}>12</option>
      <option value={24}>24</option>
      <option value={48}>48</option>
      <option value={96}>96</option>
    </select>
  );
};
export default PageSize;
